import { UserId } from "@inrev/common";
import { useMutation } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";

export const useResendAgentUserInvitation = () => {
	const { post } = useRequest();

	const mutation = useMutation({
		mutationKey: ["resendAgentUserInvitation"],
		mutationFn: async (agentId: UserId) => {
			await post(`/v2/agents/${agentId}/invite/resend`, undefined, "none");
		},
	});

	return {
		resendAgentUserInvitation: mutation.mutate,
		resendAgentUserInvitationIsLoading: mutation.isPending,
		resendAgentUserInvitationError: mutation.error,
	};
};
